// import '@comfama/comfama-ui-react/style_important.css';
import React from 'react';
import { lightTheme, ThemeProvider } from '@comfama/comfama-ui';
import './src/styles/global.css';
import { AuthProvider } from './src/contexts/authContext';
import { AppDataProvider } from './src/contexts/appDataContext';
import { CierreFinancieroProvider } from './src/herramientas/cierreFinanciero/contexts/dataContext';

import type { WrapPageElementNodeArgs } from 'gatsby';

export const wrapPageElement = ({ element }: WrapPageElementNodeArgs) => (
    <ThemeProvider customDarkTheme={lightTheme}>
        <AuthProvider>
            <AppDataProvider>
                <CierreFinancieroProvider>
                    {element}
                </CierreFinancieroProvider>
            </AppDataProvider>
        </AuthProvider>
    </ThemeProvider>
);

export const wrapRootElement = ({ element }) => (
    <AppDataProvider>
        <CierreFinancieroProvider>
            {element}
        </CierreFinancieroProvider>
    </AppDataProvider>
);
